import { Undo2 } from "lucide-react";

import { ColocaAlertDialog } from "@/shared/components/feedback/ColocaAlertDialog";
import useTranslations from "@/shared/lang/useTranslations";

export interface WithdrawBatchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
}

/** Taking a batch back from approval keeps its selection; it has to be sent again afterwards. */
export function WithdrawBatchDialog({ open, onOpenChange, onConfirm, isPending }: WithdrawBatchDialogProps) {
  const { t } = useTranslations("payoutBatches");

  return (
    <ColocaAlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next && isPending) return;
        onOpenChange(next);
      }}
      size="sm"
      media={<Undo2 className="size-8" />}
      title={t("withdraw_title")}
      description={t("withdraw_description")}
      confirmLabel={t("withdraw_confirm")}
      confirmDisabled={isPending}
      cancelLabel={t("action_close")}
      onConfirm={onConfirm}
    />
  );
}
